"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.29 8.927a1.2 1.2 0 0 1 0 2.146l-11.14 5.57c-1.193.597-2.49-.597-1.996-1.835L5.078 10 3.154 5.192C2.66 3.954 3.957 2.76 5.15 3.356zM15.306 10 4.523 4.608l-.021-.007h-.007a.1.1 0 0 0-.028.015.1.1 0 0 0-.018.027v.007q-.001.003.005.022l1.953 4.882a1.2 1.2 0 0 1 0 .892l-1.953 4.882-.006.022.001.007a.1.1 0 0 0 .018.027q.02.014.028.015h.007q.004.001.021-.007z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.179 10.7H5.787V9.3H16.18z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SendIcon20.js.map